import { Component } from '@angular/core'
import { RepositoryModal, County } from '../../shared'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './county.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class CountyComponent extends RepositoryModal<County> {}
